import { defineAction } from '~/prix'
import { z } from 'zod'
import protocolCreateAction from './protocolCreate.action.json' with { type: 'json' }
import { protocolObject } from '../protocolObject'

const protocolCreateDefinition = defineAction({
  ...protocolCreateAction,

  input: protocolObject.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    code: true,
    clientId: true,
    sourceFilter: true,
  }),
  output: z.object({
    id: z.string().uuid(),
    protocolCode: z.number().int().positive(),
  }),
})

export default protocolCreateDefinition
